<template>
  <div>
    <loader size="xxs" :loader-image="false" v-if="loading" />
    <div class="flex flex-col w-full" v-else>
      <card class="w-full flex flex-col mt-2 p-5">
        <div class="w-full gap-3 flex">
          <Card class="w-full text-darkPurple py-6 px-4" style="background: #fcf4ff">
            <div class="flex flex-col justify-center items-start gap-2">
              <Icon
                icon-name="money_bag"
                class-name="text-purple-600"
                size="xs"
              />
              <p class="text-xs text-romanSilver font-black uppercase"
                >Total Amount Disbursed (YTD)</p
              >
              <p class="text-2xl font-bold text-jet">{{
                convertToCurrency(summaryData.totalAmountDisbursed)
              }}</p>
            </div>
          </Card>
          <Card class="w-full py-6 px-4">
            <div class="flex gap-2 justify-center items-start">
              <div class="w-6 h-6">
                <Icon class="icon-stat"
                  icon-name="wallet-money"
                  class-name="text-orange-600"
                  size="xs"
                />
              </div>
              <div>
                <p class="text-xs text-romanSilver font-black uppercase"
                  >Total Amount Disbursed (YTD)</p
                >
                <p class="text-2xl font-bold text-jet">{{
                  convertToCurrency(summaryData.totalAmountDisbursed)
                }}</p>
              </div>
            </div>
          </Card>
          <Card class="w-full py-6 px-4">
            <div class="flex gap-2 justify-start items-start">
              <div class="w-6 h-6">
                <Icon class="icon-stat"
                  icon-name="wallet-money"
                  class-name="text-orange-600"
                  size="xs"
                />
              </div>
              <div>
                <p class="text-xs text-romanSilver font-black uppercase"
                  >Total Repaid (YTD)</p
                >
                <p class="text-2xl font-bold text-jet">{{
                  convertToCurrency(summaryData.totalRepaid)
                }}</p>
              </div>
            </div>
          </Card>
          <Card class="w-full py-6 p-4">
            <div class="flex gap-2 justify-center items-start">
              <div class="w-6 h-6">
                <Icon class="icon-stat"
                  icon-name="wallet-money"
                  class-name="text-orange-600"
                  size="xs"
                />
              </div>
              <div>
                <span class="text-xs text-romanSilver font-black uppercase">
                  Outstanding Balance (YTD)
                </span>
                <span class="text-2xl font-bold text-jet">{{
                  convertToCurrency(summaryData.outstandingBalance)
                }}</span>
              </div>
            </div>
          </Card>
        </div>
        <div class="flex justify-end items-end my-8">
          <button
            class="ml-3 px-4 py-2 bg-dynamicBackBtn text-white text-sm font-medium rounded-lg transition-colors"
            title="Export advance data"
            @click="handleExportData"
          >
            Export
          </button>
        </div>
        <template v-slot:footer>
          <CardFooter
            reloadcard
            printcard
            @reload="reload"
            @actionModal="viewFilterTable($event)"
            @searchResult="handleSearch($event)"
          >
          </CardFooter>
        </template>
      </card>
      <div class="flex relative">
        <Table
          :headers="advanceLoansHeader"
          :items="advanceLoansData"
          class="w-full mt-4 mb-4"
          :has-checkbox="false"
          :loading="loading"
          :pagination-list="metaData"
          @page="handlePage($event)"
          page-sync
          @itemsPerPage="handleItemsPerPage($event)"
        >
          <template v-slot:item="{ item }">
            <div
              v-if="item.employee"
              style="width: 230px"
              class="pt-3 pb-3 flex"
            >
              <div>
                <img
                  class=""
                  :src="item.data.employee.photo"
                  alt="photo"
                  v-if="item.data.employee.photo"
                  style="height: 30px; width: 30px; border-radius: 5px"
                />
                <div
                  style="height: 30px; width: 30px; border-radius: 5px"
                  class="text-blueCrayola border text-center font-semibold pt-2"
                  v-else
                >
                  {{
                    $getInitials(
                      `${item.data.employee.fname} ${item.data.employee.lname}`
                    )
                  }}
                </div>
              </div>
              <div class="flex flex-col">
                <span
                  class="font-bold cursor-pointer ml-2 capitalize"
                  style="color: #321c3b"
                  >{{ item.data.employee.fname }}
                  {{ item.data.employee.lname }}</span
                >
                <span class="cursor-pointer ml-2 capitalize text-gray-500">{{
                  item.data.employee.designation
                    ? item.data.employee.designation
                    : "-----"
                }}</span>
              </div>
            </div>
            <div v-if="item.principalAmount">
              <span>
                {{ convertToCurrency(item.data.principalAmount) }}
              </span>
            </div>
            <div v-if="item.interestAmount">
              <span>
                {{ convertToCurrency(item.data.interestAmount) }}
              </span>
            </div>
            <div v-if="item.repaymentAmount">
              <span>
                {{ convertToCurrency(item.data.repaymentAmount) }}
              </span>
            </div>
            <div v-if="item.amountRepaidToDate">
              <span>
                {{ convertToCurrency(item.data.amountRepaidToDate) }}
              </span>
            </div>
            <div v-if="item.outstandingBalance">
              <span>
                {{ convertToCurrency(item.data.outstandingBalance) }}
              </span>
            </div>
            <div
              v-if="item.approvalStatus"
              style="width: 100px"
              class="p-3"
              :class="{
                pending: item.data.approvalStatus === 'pending',
                approved: item.data.approvalStatus === 'approved',
                disapproved: item.data.approvalStatus === 'disapproved',
              }"
            >
              <div class="w-auto capitalize flex flex-col">
                <p class="text-sm font-semibold">
                  {{ Capitalize(item.data.approvalStatus) }}
                </p>
              </div>
            </div>
            <div v-if="item.paySetting">
              <span>
                {{ 
                  item.data.paySetting
                    ? item.data.paySetting.nameOnPayslip
                    : "-----"
                }}
              </span>
            </div>
            <span v-else-if="item.id">
              <Menu left top="-150" margin="24" class="my-2 p-0">
                <template v-slot:title>
                  <icon icon-name="more_icon" size="xs" />
                </template>
              </Menu>
            </span>
          </template>
        </Table>
        <div class="absolute top-6 right-3 bg-transparent w-9 h-8 cursor-pointer" 
          @click="isHeadersOptions = !isHeadersOptions"
        > 
        </div>
        <div class="width absolute top right-0" v-if="isHeadersOptions">
          <card class="w-full p-3">
            <p class="w-full text-xs text-romanSilver font-black border-gray">
              [Table] View & ORDER
            </p>
            <div v-for="(header, index) in headersOptions" class="w-full px-2">
              <div class="w-full flex justify-between items-center py-2 text-sm"
                :class="index === 6 && 'border-gray'"
              >
                <div class="flex justify-start items-center gap-1">
                  <div>
                    <icon icon-name="reorder-icon" size="xs" />
                  </div>
                  <p
                    :style="{ color: header.color }"
                  >
                    {{ header.title }}
                  </p>
                </div>

                <div
                  :class="isLastTwoEditableOptions(index) ? 'cursor-pointer' : ''"
                >
                  <icon :icon-name="header.color === '#321C3B' ? 'green-eye-icon' : 'gray-eye-icon'" size="xs" />
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <card class="p-5 w-full flex gap-9">
        <div class="w-max text-lg mr-5 font-bold text-darkPurple">Total</div>
        <div
          class="w-2/12 border border-dashed mr-5 mt-4"
          style="height: 1px"
        />
        <div class="flex w-9/12 gap-3">
          <div class="mt-1 w-full">
            <p class="font-black uppercase text-romanSilver text-xs">
              Total Principal
            </p>
            <p class="text-lg font-bold text-darkPurple">
              {{ convertToCurrency(totalPrincipalAmt) }}
            </p>
          </div>
          <div class="mt-1 w-full">
            <p class="font-black uppercase text-romanSilver text-xs">
              Total Interest
            </p>
            <p class="text-lg font-bold text-darkPurple">
              {{ convertToCurrency(totalInterestAmt) }}
            </p>
          </div>
          <div class="w-full mt-1">
            <p class="font-black uppercase text-romanSilver text-xs">
              Total Repayable
            </p>
            <p class="text-lg font-bold text-darkPurple">
              {{ convertToCurrency(totalRepaymentAmt) }}
            </p>
          </div>
          <div class="w-full mt-1">
            <p class="font-black uppercase text-romanSilver text-xs">
              Total Paid
            </p>
            <p class="text-lg font-bold text-darkPurple">
              {{ convertToCurrency(totalRepaid) }}
            </p>
          </div>
          <div class="w-full mt-1">
            <p class="font-black uppercase text-romanSilver text-xs">
              Total Outstanding
            </p>
            <p class="text-lg font-bold text-blueCrayola">
              {{ convertToCurrency(totalOutstanding) }}
            </p>
          </div>
        </div>
      </card>
    </div>

    <FilterTable
      v-if="filterTable"
      :filter-data="filterArray"
      @close="closeFilter($event)"
      @getParams="searchFilter($event)"
    />
  </div>
</template>

<script>
import SearchInput from "@scelloo/cloudenly-ui/src/components/search-input";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import CardFooter from "@/components/CardFooter";
import FilterTable from "@/components/FilterTable";

export default {
  name: "ConsolidatedAdvance",
  components: {
    Card,
    Icon,
    SearchInput,
    CSelect,
    CardFooter,
    Table,
    FilterTable,
  },
  props: {
    mode: {
      type: String,
      default: "admin",
    },
  },
  data() {
    return {
      isHeadersOptions: false,
      headersOptions: [
        { title: "EMPLOYEE", color: "#321C3B" },
        { title: "PRINCIPAL", color: "#321C3B" },
        { title: "Total Interest", color: "#321C3B" },
        { title: "Amount Repayable", color:"#321C3B" },
        { title: "Repaid to Date", color: "#321C3B" },
        { title: "Oustanding Balance", color: "#321C3B" },
        { title: "Status", color: "#321C3B" },
        { title: "Request type", color: "#321C3B" },
      ],
      advanceLoansHeader: [
        { title: "EMPLOYEE", value: "employee" },
        { title: "PRINCIPAL", value: "principalAmount" },
        { title: "Total Interest", value: "interestAmount" },
        { title: "Amount Repayable", value: "repaymentAmount" },
        { title: "Repaid to Date", value: "amountRepaidToDate" },
        { title: "Oustanding Balance", value: "outstandingBalance" },
        { title: "Status", value: "approvalStatus" },
        { title: "Request type", value: "paySetting" },
        { title: "", value: "id", image: true },
      ],
      advanceLoansData: [],
      summaryData: {},
      totalPrincipalAmt: 0,
      totalInterestAmt: 0,
      totalRepaymentAmt: 0,
      totalRepaid: 0,
      totalOutstanding: 0,
      loading: false,
      metaData: {},
      itemsPerPage: 50,
      searchWord: null,
      numberOfPage: 1,
      filterTable: false,
      advanceTimeline: {},
      filterArray: [
        { header: "Location(s)", value: "locationId", optionsBox: [] },
        { header: "Level(s)", value: "levelId", optionsBox: [] },
        { header: "Function(s)", value: "functionId", optionsBox: [] },
        { header: "Designation(s)", value: "designationId", optionsBox: [] },
        { header: "Status", value: "status", optionsBox: [] },
      ],
    };
  },
  methods: {
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },
    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },
    handleSearch(searchWord) {
      if (searchWord) {
        this.searchWord = searchWord;
        this.queryUpdate();
      } else {
        this.searchWord = null;
        this.queryUpdate();
      }
    },
    queryUpdate() {
      const search = this.searchWord ? `&search=${this.searchWord}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getRequests(`${pageNumber}${itemPage}${search}`);
    },
    getRequests(params) {
      this.loading = true;
      this.advanceLoansData = [];
      this.totalPrincipalAmt = 0;
      this.totalInterestAmt = 0;
      this.totalOutstanding = 0;
      this.totalRepaid = 0;
      this.totalRepaymentAmt = 0;
      if (this.mode !== "ess") {
        this.$_getAdminConsolidatedEmployees()
          .then(({ data }) => {
            this.reuseRequest(data);
          })
          .catch(() => {
            this.loading = false;
          }); 
      } else {
        this.$_getManagerConsolidatedAdvanceAndLoanForEmployees(params)
          .then(({ data }) => {
            this.reuseRequest(data);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    reuseRequest(data){
      this.summaryData = data.stats.ytd
      this.advanceLoansData = data.data;
      this.advanceLoansData = this.advanceLoansData.map((element) => ({
        employee: element.employee,
        amountRepaidToDate: element.amountRepaidToDate,
        outstandingBalance: element.outstandingBalance,
        ...element,
      }));
      this.metaData = data.meta;
      this.totalPrincipalAmt = data.stats.totals.totalPrincipal;
      this.totalInterestAmt = data.stats.totals.totalInterest;
      this.totalOutstanding = data.stats.totals.totalOutstanding;
      this.totalRepaid = data.stats.totals.totalPaid;
      this.totalRepaymentAmt = data.stats.totals.totalRepayable;
      this.loading = false;
    },
    async requestAdvance() {
      if (this.mode === "ess") {
        this.showError = false;
        this.getRequests("&page=1&perPage=50");
        return;
      }
      try {
        await this.$handlePrivilege("advance", "viewRegister");
        this.showError = false;
        this.getRequests("&page=1&perPage=50");
      } catch (error) {
        this.showError = true;
      }
    },

    reload() {
      this.requestAdvance();
    },

    viewFilterTable(value) {
      if (value) {
        this.filterTable = true;
      }
    },

    closeFilter(val) {
      if (val) {
        this.filterTable = false;
      }
    },

    searchFilter(params) {
      this.getRequests(params);
      this.filterTable = false;
    },
    async handleExportData(){
      const type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const extension = ".xlsx"
      try {
        if (this.mode !== "ess") {
          const { data } = await this.$_exportAdminConsolidatedEmployees();
          const name = 'Consolidated Employees Advances And Loans';
          this.$exportFile(data, name, type, extension);
          this.$toasted.success("Data exported successfully!", { duration: 5000 });
        }else{
          const { data } = await this.$_exportManagerConsolidatedEmployees();
          const name = 'Consolidated Employees Advances And Loans';
          this.$exportFile(data, name, type, extension);
          this.$toasted.success("Data exported successfully!", { duration: 5000 });
        }
      } catch (error) {
        const decodedData = new TextDecoder().decode(error.response.data);
        const errorMessage = JSON.parse(decodedData);
        this.$toasted.error(errorMessage.message, { duration: 5000 });
      }
    },

    getAllFunctions() {
      this.$_getFunction().then((response) => {
        response.data.functions.map((functionVal) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Function(s)") {
              filter.optionsBox.push({
                id: functionVal.id,
                name: functionVal.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllDesignations() {
      this.$_getDesignations("").then((response) => {
        response.data.designations.map((designation) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Designation(s)") {
              filter.optionsBox.push({
                id: designation.id,
                name: designation.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllLocations() {
      this.$_getHumanarLocations("").then((response) => {
        response.data.outlets.map((outlet) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Location(s)") {
              filter.optionsBox.push({
                id: outlet.id,
                name: outlet.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllLevels() {
      this.$_getLevels().then((response) => {
        response.data.levels.map((outlet) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Level(s)") {
              filter.optionsBox.push({
                id: outlet.id,
                name: outlet.name,
              });
            }
          });
          return {};
        });
      });
    },

    getStatus() {
      this.filterArray.forEach((filter) => {
        if (filter.header === "Status") {
          filter.optionsBox.push(
            {
              id: "pending",
              name: "Pending",
            },
            {
              id: "approved",
              name: "Approved",
            },
            {
              id: "disapproved",
              name: "Disapproved",
            }
          );
        }
      });
    },
    isLastTwoEditableOptions(index) {
      return index === this.headersOptions.length - 1;
    },
  },
  mounted() {
    this.getRequests("");
    this.getAllFunctions();
    this.getAllDesignations();
    this.getAllLocations();
    this.getAllLevels();
    this.getStatus();
  },
};
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  padding: 3px;
}
.icon-stat{
  width: 100% !important;
  height: 100% !important;
}
.m-top{
  padding-top: -16px !important;
}
.width{
  width: 251px !important
}
.border-gray{
  border-bottom: 0.5px solid #878E99 !important
}
.top{
  top: 65px !important;
}
</style>